import { useRef, useState, useEffect } from "react";
import { CheckPicker, DateRangePicker } from "rsuite";
import { Button as CustomButton } from "..";
import "./index.css";

function isDateColumn(column) {
  // Add more date columns as needed
  return column === "postingDate" || column === "createdAt";
}

function FilterPanel({
  activeColumn,
  filterOptions = [],
  selectedValues = [],
  onApply,
  onCancel,
  onFilterChange
}) {
  const filterCheckboxRef = useRef(null);
  const [dateRangeValue, setDateRangeValue] = useState(null);

  // Initialize and update date range value when selectedValues change
  useEffect(() => {
    if (isDateColumn(activeColumn)) {
      if (Array.isArray(selectedValues) && selectedValues.length === 2) {
        const startDate = selectedValues[0] instanceof Date ? selectedValues[0] : (selectedValues[0] ? new Date(selectedValues[0]) : null);
        const endDate = selectedValues[1] instanceof Date ? selectedValues[1] : (selectedValues[1] ? new Date(selectedValues[1]) : null);
        
        if (startDate && endDate && !isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
          setDateRangeValue([startDate, endDate]);
        } else {
          setDateRangeValue(null);
        }
      } else {
        setDateRangeValue(null);
      }
    }
  }, [selectedValues, activeColumn]);

  const handleDateRangeChange = (range) => {
    setDateRangeValue(range);
    onFilterChange(range);
  };

  return (
    <div
      className="checkpicker-container"
      data-testid="filter-panel"
      style={{
        marginBottom: "10px",
        padding: "10px",
        border: "1px solid #e5e5ea",
        borderRadius: "6px",
      }}
    >
      <label
        style={{
          marginRight: "10px",
          fontWeight: "bold",
        }}
      >
        Filter by {activeColumn}:
      </label>
      {isDateColumn(activeColumn) ? (
        <div style={{ marginBottom: 8 }}>
          <DateRangePicker
            data-testid="filter-select-date-range"
            value={dateRangeValue}
            onChange={handleDateRangeChange}
            cleanable={false}
            format="dd/MM/yyyy"
            placeholder="DD/MM/YYYY - DD/MM/YYYY"
            style={{ width: 300 }}
          />
        </div>
      ) : (
        <CheckPicker
          data={filterOptions}
          onChange={onFilterChange}
          ref={filterCheckboxRef}
          defaultValue={selectedValues}
          onClean={() => {
            if (filterCheckboxRef.current) {
              filterCheckboxRef.current.value = [];
            }
            onFilterChange([]);
          }}
          placeholder="Select values"
          style={{ width: 450 }}
          preventOverflow
          cleanable
          virtualized
          searchable
          listProps={{
            height: 300,
            rowHeight: 30,
            bordered: false,
            hover: false,
          }}
          menuStyle={{
            padding: 0,
          }}
        />
      )}
      <CustomButton text="Apply" onClick={onApply} className="filter-button">
        Apply
      </CustomButton>
      <CustomButton text="Cancel" color="blue" onClick={onCancel} className="filter-button">
      </CustomButton>
    </div>
  );
}

export default FilterPanel;
